export default __webpack_public_path__ + "static/media/sales-icon.fe63363f.svg";